import store from '@/store'

export default {
  requireUser (to, from, next) {
    if (store.state.isLogged === true && localStorage.getItem('expirationDate') && localStorage.getItem('token')) {
      next()
    } else {
      next('/jauschneg-admin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js